<template>
  <div class="risk-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
        <!-- 风控规则 -->
        <el-tab-pane label="风控规则" name="rules">
          <div class="filter-card">
            <div class="filter-bar">
              <div class="filter-group">
                <el-button type="success" icon="el-icon-plus" @click="handleAddRule">新增</el-button>
              </div>
            </div>
          </div>
          <div v-if="error" class="error">{{ error }}</div>
          <el-table
            v-else
            :data="rules"
            border
            stripe
            v-loading="rulesLoading"
            element-loading-text="正在加载..."
            class="animate__animated animate__fadeIn"
            row-key="id"
          >
            <el-table-column prop="id" label="ID" width="80" align="center" />
            <el-table-column prop="ruleKey" label="规则键" min-width="150" show-overflow-tooltip />
            <el-table-column prop="params" label="参数" min-width="150" show-overflow-tooltip />
            <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip />
            <el-table-column prop="enable" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.enable === 1 || scope.row.enable === '1'" type="success" size="small">启用</el-tag>
                <el-tag v-else type="info" size="small">禁用</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEditRule(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="rulesPagination.page"
              :page-size="rulesPagination.pageSize"
              :page-sizes="[5, 10, 20, 50]"
              :total="rulesPagination.total"
              @current-change="handleRulesPageChange"
              @size-change="handleRulesSizeChange"
            />
          </div>
        </el-tab-pane>

        <!-- 风控名单 -->
        <el-tab-pane label="风控名单" name="list">
          <div class="filter-card">
            <div class="filter-bar">
              <div class="filter-group">
                <el-select
                  v-model="controlSearchListType"
                  placeholder="名单类型"
                  clearable
                  class="filter-select"
                  @change="handleControlSearch"
                >
                  <el-option value="pkg_whitelist" label="包名白名单" />
                  <el-option value="pkg_blacklist" label="包名黑名单" />
                  <el-option value="device_blacklist" label="设备黑名单" />
                </el-select>
                <el-button type="success" icon="el-icon-plus" @click="handleAddControlItem">新增</el-button>
              </div>
            </div>
          </div>

          <div v-if="error" class="error">{{ error }}</div>
          <el-empty
            v-else-if="!controlLoading && controlList.length === 0"
            description="暂无风控名单数据"
          />

          <div v-else>
            <el-table
              :data="controlList"
              border
              stripe
              v-loading="controlLoading"
              element-loading-text="正在加载..."
              class="animate__animated animate__fadeIn"
              row-key="id"
            >
              <el-table-column prop="id" label="ID" width="80" align="center" />
              <el-table-column prop="listType" label="类型" min-width="130" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.listType === 'pkg_whitelist'" type="success" size="small">包名白名单</el-tag>
                  <el-tag v-else-if="scope.row.listType === 'pkg_blacklist'" type="danger" size="small">包名黑名单</el-tag>
                  <el-tag v-else-if="scope.row.listType === 'device_blacklist'" type="warning" size="small">设备黑名单</el-tag>
                  <span v-else>{{ scope.row.listType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="itemValue" label="名单内容" min-width="200" show-overflow-tooltip />
              <el-table-column prop="description" label="描述" min-width="160" show-overflow-tooltip />
              <el-table-column prop="isActive" label="是否生效" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.isActive === 1 || scope.row.isActive === '1'" type="success" size="small">是</el-tag>
                  <el-tag v-else type="info" size="small">否</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleEditControlItem(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDeleteControlItem(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="controlPagination.total > 0" class="pagination-container">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="controlPagination.page"
              :page-size="controlPagination.pageSize"
              :page-sizes="[5, 10, 20, 50]"
              :total="controlPagination.total"
              @current-change="handleControlPageChange"
              @size-change="handleControlSizeChange"
            />
          </div>
        </el-tab-pane>

        <!-- 阿里云风控 -->
        <el-tab-pane label="阿里云风控" name="aliyun">
          <div class="filter-card">
            <div class="filter-bar">
              <div class="filter-group">
                <el-input
                  v-model="aliyunSearchKeyword"
                  placeholder="标识 / 名称 / 含义"
                  clearable
                  class="filter-select"
                  style="width: 200px;"
                  @keyup.enter.native="handleAliyunSearch"
                  @clear="handleAliyunSearch"
                />
                <el-select
                  v-model="aliyunSearchTagType"
                  placeholder="标签类型"
                  clearable
                  class="filter-select"
                  @change="handleAliyunSearch"
                >
                  <el-option v-for="item in aliyunTagTypes" :key="item" :value="item" :label="item" />
                </el-select>
                <el-select
                  v-model="aliyunSearchEnabled"
                  placeholder="启用状态"
                  clearable
                  class="filter-select"
                  @change="handleAliyunSearch"
                >
                  <el-option :value="1" label="启用" />
                  <el-option :value="0" label="禁用" />
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="handleAliyunSearch">查询</el-button>
                <el-button type="success" icon="el-icon-plus" @click="handleAddAliyunTag">新增</el-button>
              </div>
            </div>
          </div>

          <div v-if="error" class="error">{{ error }}</div>
          <el-table
            v-else
            :data="aliyunTags"
            border
            stripe
            v-loading="aliyunLoading"
            element-loading-text="正在加载..."
            class="animate__animated animate__fadeIn"
            row-key="id"
          >
            <el-table-column prop="id" label="ID" width="70" align="center" />
            <el-table-column prop="tagState" label="标签标识" min-width="170" show-overflow-tooltip />
            <el-table-column prop="tagMean" label="标签含义" min-width="160" show-overflow-tooltip />
            <el-table-column prop="tagType" label="类型" min-width="120" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.tagType === '设备风险类'" type="danger" size="small">设备风险类</el-tag>
                <el-tag v-else-if="scope.row.tagType === 'web设备风险类'" type="warning" size="small">web设备风险类</el-tag>
                <el-tag v-else-if="scope.row.tagType === '批量行为类'" type="info" size="small">批量行为类</el-tag>
                <span v-else>{{ scope.row.tagType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="tagDesc" label="描述" min-width="220" show-overflow-tooltip />
            <el-table-column prop="enabled" label="状态" width="90" align="center">
              <template slot-scope="scope">
                <el-switch
                  :value="Number(scope.row.enabled) === 1"
                  @change="(val) => handleToggleAliyunEnabled(scope.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="170" align="center">
              <template slot-scope="scope">
                {{ formatTagTime(scope.row.updateTime) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEditAliyunTag(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDeleteAliyunTag(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="aliyunPagination.page"
              :page-size="aliyunPagination.pageSize"
              :page-sizes="[5, 10, 20, 50]"
              :total="aliyunPagination.total"
              @current-change="handleAliyunPageChange"
              @size-change="handleAliyunSizeChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 风控规则新增/编辑对话框 -->
    <el-dialog
      :title="ruleDialogTitle"
      :visible.sync="ruleDialogVisible"
      width="500px"
      append-to-body
      @close="handleRuleDialogClose"
    >
      <el-form :model="ruleForm" :rules="ruleRules" ref="ruleForm" label-width="100px">
        <el-form-item label="规则键" prop="ruleKey">
          <el-input v-model="ruleForm.ruleKey" :disabled="isRuleEdit" placeholder="请输入规则键" />
        </el-form-item>
        <el-form-item label="参数" prop="params">
          <el-input v-model="ruleForm.params" placeholder="请输入参数值" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="ruleForm.description" type="textarea" :rows="3" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="状态" prop="enable">
          <el-radio-group v-model="ruleForm.enable">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ruleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRuleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 风控名单新增/编辑对话框 -->
    <el-dialog
      :title="controlDialogTitle"
      :visible.sync="controlDialogVisible"
      width="500px"
      append-to-body
      @close="handleControlDialogClose"
    >
      <el-form :model="controlForm" :rules="controlRules" ref="controlForm" label-width="100px">
        <el-form-item label="名单类型" prop="listType">
          <el-select v-model="controlForm.listType" placeholder="请选择名单类型" style="width: 100%;">
            <el-option value="pkg_whitelist" label="包名白名单" />
            <el-option value="pkg_blacklist" label="包名黑名单" />
            <el-option value="device_blacklist" label="设备黑名单" />
          </el-select>
        </el-form-item>
        <el-form-item label="名单内容" prop="itemValue">
          <el-input v-model="controlForm.itemValue" placeholder="请输入名单内容（如IP、设备ID等）" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="controlForm.description" type="textarea" :rows="3" placeholder="请输入描述（如封禁原因等）" />
        </el-form-item>
        <el-form-item label="是否生效" prop="isActive">
          <el-radio-group v-model="controlForm.isActive">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="controlDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleControlSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 阿里云风控标签新增/编辑对话框 -->
    <el-dialog
      :title="aliyunDialogTitle"
      :visible.sync="aliyunDialogVisible"
      width="560px"
      append-to-body
      @close="handleAliyunDialogClose"
    >
      <el-form :model="aliyunForm" :rules="aliyunRules" ref="aliyunForm" label-width="110px">
        <el-form-item label="标签标识" prop="tagState">
          <el-input v-model="aliyunForm.tagState" placeholder="如 is_emulator，需与阿里云 tags 一致" />
        </el-form-item>
        <el-form-item label="标签含义" prop="tagMean">
          <el-input v-model="aliyunForm.tagMean" placeholder="请输入标签含义" />
        </el-form-item>
        <el-form-item label="标签类型" prop="tagType">
          <el-select v-model="aliyunForm.tagType" placeholder="请选择标签类型" style="width: 100%;" allow-create filterable>
            <el-option v-for="item in aliyunTagTypes" :key="item" :value="item" :label="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="详细描述" prop="tagDesc">
          <el-input v-model="aliyunForm.tagDesc" type="textarea" :rows="3" placeholder="请输入标签详细描述" />
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-radio-group v-model="aliyunForm.enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="aliyunDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAliyunSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, getResponseMessage } from '@/utils/http'

export default {
  name: 'RiskManagement',
  data() {
    return {
      activeTab: 'rules',
      error: '',

      // 风控规则
      rules: [],
      rulesLoading: false,
      rulesPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      ruleDialogVisible: false,
      ruleDialogTitle: '编辑风控规则',
      isRuleEdit: false,
      ruleForm: {
        id: null,
        ruleKey: '',
        params: null,
        description: '',
        enable: 1
      },
      ruleRules: {
        ruleKey: [
          { required: true, message: '请输入规则键', trigger: 'blur' }
        ],
        params: []
      },

      // 风控名单
      controlList: [],
      controlLoading: false,
      controlSearchListType: '',
      controlPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      controlDialogVisible: false,
      controlDialogTitle: '新增风控名单',
      isControlEdit: false,
      controlForm: {
        id: null,
        listType: 'pkg_blacklist',
        itemValue: '',
        description: '',
        isActive: 1
      },
      controlRules: {
        listType: [
          { required: true, message: '请选择名单类型', trigger: 'change' }
        ],
        itemValue: [
          { required: true, message: '请输入名单内容', trigger: 'blur' }
        ]
      },

      // 阿里云风控
      aliyunTags: [],
      aliyunLoading: false,
      aliyunSearchKeyword: '',
      aliyunSearchTagType: '',
      aliyunSearchEnabled: '',
      aliyunTagTypes: ['设备风险类', 'web设备风险类', '批量行为类'],
      aliyunPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      aliyunDialogVisible: false,
      aliyunDialogTitle: '新增阿里云风控标签',
      isAliyunEdit: false,
      aliyunForm: {
        id: null,
        tagState: '',
        tagMean: '',
        tagType: '设备风险类',
        tagDesc: '',
        enabled: 1
      },
      aliyunRules: {
        tagState: [
          { required: true, message: '请输入标签标识', trigger: 'blur' }
        ],
        tagMean: [
          { required: true, message: '请输入标签含义', trigger: 'blur' }
        ],
        tagType: [
          { required: true, message: '请选择标签类型', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.fetchRules()
  },
  methods: {
    handleTabClick(tab) {
      this.error = ''
      if (tab.name === 'rules') {
        this.fetchRules()
      } else if (tab.name === 'list') {
        this.fetchControlList()
      } else if (tab.name === 'aliyun') {
        this.fetchAliyunTags()
      }
    },

    // ==================== 风控规则 ====================
    async fetchRules() {
      this.rulesLoading = true
      this.error = ''
      try {
        const params = {
          page: this.rulesPagination.page,
          pageSize: this.rulesPagination.pageSize
        }
        const result = await get('/admin/risk/rules', params)
        const data = result && result.data ? result.data : {}
        this.rules = Array.isArray(data.records) ? data.records : (Array.isArray(data) ? data : [])
        this.rulesPagination.total = data.total || 0
        this.rulesPagination.page = data.page || this.rulesPagination.page
        this.rulesPagination.pageSize = data.pageSize || this.rulesPagination.pageSize
      } catch (e) {
        this.error = e && e.message ? e.message : '获取风控规则失败'
        this.rules = []
        this.rulesPagination.total = 0
      } finally {
        this.rulesLoading = false
      }
    },

    handleRulesPageChange(page) {
      this.rulesPagination.page = page
      this.fetchRules()
    },

    handleRulesSizeChange(size) {
      this.rulesPagination.pageSize = size
      this.rulesPagination.page = 1
      this.fetchRules()
    },

    handleEditRule(row) {
      this.ruleDialogTitle = '编辑风控规则'
      this.isRuleEdit = true
      this.ruleForm = {
        id: row.id,
        ruleKey: row.ruleKey || '',
        params: row.params != null ? String(row.params) : '',
        description: row.description || '',
        enable: row.enable != null ? Number(row.enable) : 1
      }
      this.ruleDialogVisible = true
    },

    handleAddRule() {
      this.ruleDialogTitle = '新增风控规则'
      this.isRuleEdit = false
      this.ruleForm = {
        id: null,
        ruleKey: '',
        params: null,
        description: '',
        enable: 1
      }
      this.ruleDialogVisible = true
    },

    handleRuleDialogClose() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
    },

    handleRuleSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        try {
          const payload = {
            ruleKey: this.ruleForm.ruleKey,
            params: this.ruleForm.params,
            description: this.ruleForm.description,
            enable: this.ruleForm.enable
          }
          let result
          if (this.isRuleEdit) {
            payload.id = this.ruleForm.id
            result = await post('/admin/risk/rules/update', payload)
          } else {
            result = await post('/admin/risk/rules/add', payload)
          }
          this.ruleDialogVisible = false
          this.$message.success(getResponseMessage(result, this.isRuleEdit ? '更新成功' : '添加成功'))
          this.fetchRules()
        } catch (e) {
          this.$message.error(e.message || '操作失败')
        }
      })
    },

    handleDeleteRule(row) {
      this.$confirm(`确定要删除该风控规则吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const result = await post('/admin/risk/rules/delete', { id: row.id })
          this.$message.success(getResponseMessage(result, '删除成功'))
          // 如果当前页只剩最后一条且不是第一页，回到上一页
          if (this.rules.length === 1 && this.rulesPagination.page > 1) {
            this.rulesPagination.page = this.rulesPagination.page - 1
          }
          this.fetchRules()
        } catch (e) {
          this.$message.error(e.message || '删除失败')
        }
      }).catch(() => {})
    },

    // ==================== 风控名单 ====================
    async fetchControlList() {
      this.controlLoading = true
      this.error = ''
      try {
        const params = {
          page: this.controlPagination.page,
          pageSize: this.controlPagination.pageSize
        }
        if (this.controlSearchListType) {
          params.listType = this.controlSearchListType
        }
        const result = await get('/admin/risk/list', params)
        const data = result && result.data ? result.data : {}
        this.controlList = Array.isArray(data.records) ? data.records : (Array.isArray(data) ? data : [])
        this.controlPagination.total = data.total || 0
        this.controlPagination.page = data.page || this.controlPagination.page
        this.controlPagination.pageSize = data.pageSize || this.controlPagination.pageSize
      } catch (e) {
        this.error = e && e.message ? e.message : '获取风控名单失败'
        this.controlList = []
        this.controlPagination.total = 0
      } finally {
        this.controlLoading = false
      }
    },

    handleControlSearch() {
      this.controlPagination.page = 1
      this.fetchControlList()
    },

    handleControlPageChange(page) {
      this.controlPagination.page = page
      this.fetchControlList()
    },

    handleControlSizeChange(size) {
      this.controlPagination.pageSize = size
      this.controlPagination.page = 1
      this.fetchControlList()
    },

    handleAddControlItem() {
      this.controlDialogTitle = '新增风控名单'
      this.isControlEdit = false
      this.controlForm = {
        id: null,
        listType: 'pkg_blacklist',
        itemValue: '',
        description: '',
        isActive: 1
      }
      this.controlDialogVisible = true
    },

    handleEditControlItem(row) {
      this.controlDialogTitle = '编辑风控名单'
      this.isControlEdit = true
      this.controlForm = {
        id: row.id,
        listType: row.listType || '',
        itemValue: row.itemValue || '',
        description: row.description || '',
        isActive: row.isActive != null ? Number(row.isActive) : 1
      }
      this.controlDialogVisible = true
    },

    handleControlDialogClose() {
      this.$refs.controlForm && this.$refs.controlForm.resetFields()
    },

    handleControlSubmit() {
      this.$refs.controlForm.validate(async (valid) => {
        if (!valid) return
        try {
          const payload = {
            listType: this.controlForm.listType,
            itemValue: this.controlForm.itemValue,
            description: this.controlForm.description,
            isActive: this.controlForm.isActive
          }
          let result
          if (this.isControlEdit) {
            payload.id = this.controlForm.id
            result = await post('/admin/risk/list/update', payload)
          } else {
            result = await post('/admin/risk/list/add', payload)
          }
          this.controlDialogVisible = false
          this.$message.success(getResponseMessage(result, this.isControlEdit ? '更新成功' : '添加成功'))
          this.fetchControlList()
        } catch (e) {
          this.$message.error(e.message || '操作失败')
        }
      })
    },

    handleDeleteControlItem(row) {
      this.$confirm(`确定要删除此风控名单项吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const result = await post('/admin/risk/list/delete', { id: row.id })
          this.$message.success(getResponseMessage(result, '删除成功'))
          // 如果当前页只剩最后一条且不是第一页，回到上一页
          if (this.controlList.length === 1 && this.controlPagination.page > 1) {
            this.controlPagination.page = this.controlPagination.page - 1
          }
          this.fetchControlList()
        } catch (e) {
          this.$message.error(e.message || '删除失败')
        }
      }).catch(() => {})
    },

    // ==================== 阿里云风控 ====================
    formatTagTime(ts) {
      if (ts == null || ts === '') return '-'
      const d = new Date(Number(ts))
      if (Number.isNaN(d.getTime())) return String(ts)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },

    async fetchAliyunTags() {
      this.aliyunLoading = true
      this.error = ''
      try {
        const params = {
          page: this.aliyunPagination.page,
          pageSize: this.aliyunPagination.pageSize
        }
        if (this.aliyunSearchKeyword) {
          params.keyword = this.aliyunSearchKeyword
        }
        if (this.aliyunSearchTagType) {
          params.tagType = this.aliyunSearchTagType
        }
        if (this.aliyunSearchEnabled !== '' && this.aliyunSearchEnabled !== null) {
          params.enabled = this.aliyunSearchEnabled
        }
        const result = await get('/admin/risk/aliyun-tags', params)
        const data = result && result.data ? result.data : {}
        this.aliyunTags = Array.isArray(data.records) ? data.records : (Array.isArray(data) ? data : [])
        this.aliyunPagination.total = data.total || 0
        this.aliyunPagination.page = data.page || this.aliyunPagination.page
        this.aliyunPagination.pageSize = data.pageSize || this.aliyunPagination.pageSize
      } catch (e) {
        this.error = e && e.message ? e.message : '获取阿里云风控标签失败'
        this.aliyunTags = []
        this.aliyunPagination.total = 0
      } finally {
        this.aliyunLoading = false
      }
    },

    handleAliyunSearch() {
      this.aliyunPagination.page = 1
      this.fetchAliyunTags()
    },

    handleAliyunPageChange(page) {
      this.aliyunPagination.page = page
      this.fetchAliyunTags()
    },

    handleAliyunSizeChange(size) {
      this.aliyunPagination.pageSize = size
      this.aliyunPagination.page = 1
      this.fetchAliyunTags()
    },

    handleAddAliyunTag() {
      this.aliyunDialogTitle = '新增阿里云风控标签'
      this.isAliyunEdit = false
      this.aliyunForm = {
        id: null,
        tagState: '',
        tagMean: '',
        tagType: '设备风险类',
        tagDesc: '',
        enabled: 1
      }
      this.aliyunDialogVisible = true
    },

    handleEditAliyunTag(row) {
      this.aliyunDialogTitle = '编辑阿里云风控标签'
      this.isAliyunEdit = true
      this.aliyunForm = {
        id: row.id,
        tagState: row.tagState || '',
        tagMean: row.tagMean || '',
        tagType: row.tagType || '设备风险类',
        tagDesc: row.tagDesc || '',
        enabled: row.enabled != null ? Number(row.enabled) : 1
      }
      this.aliyunDialogVisible = true
    },

    handleAliyunDialogClose() {
      this.$refs.aliyunForm && this.$refs.aliyunForm.resetFields()
    },

    buildAliyunPayload() {
      return {
        tagState: this.aliyunForm.tagState,
        tagMean: this.aliyunForm.tagMean,
        tagType: this.aliyunForm.tagType,
        tagDesc: this.aliyunForm.tagDesc,
        enabled: this.aliyunForm.enabled
      }
    },

    handleAliyunSubmit() {
      this.$refs.aliyunForm.validate(async (valid) => {
        if (!valid) return
        try {
          const payload = this.buildAliyunPayload()
          let result
          if (this.isAliyunEdit) {
            payload.id = this.aliyunForm.id
            result = await post('/admin/risk/aliyun-tags/update', payload)
          } else {
            result = await post('/admin/risk/aliyun-tags/add', payload)
          }
          this.aliyunDialogVisible = false
          this.$message.success(getResponseMessage(result, this.isAliyunEdit ? '更新成功' : '添加成功'))
          this.fetchAliyunTags()
        } catch (e) {
          this.$message.error(e.message || '操作失败')
        }
      })
    },

    async handleToggleAliyunEnabled(row, enabled) {
      try {
        const result = await post('/admin/risk/aliyun-tags/update', {
          id: row.id,
          tagState: row.tagState,
          tagMean: row.tagMean,
          tagType: row.tagType,
          tagDesc: row.tagDesc,
          enabled: enabled ? 1 : 0
        })
        this.$message.success(getResponseMessage(result, enabled ? '已启用' : '已禁用'))
        this.fetchAliyunTags()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },

    handleDeleteAliyunTag(row) {
      this.$confirm(`确定要删除标签「${row.tagState}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const result = await post('/admin/risk/aliyun-tags/delete', { id: row.id })
          this.$message.success(getResponseMessage(result, '删除成功'))
          if (this.aliyunTags.length === 1 && this.aliyunPagination.page > 1) {
            this.aliyunPagination.page = this.aliyunPagination.page - 1
          }
          this.fetchAliyunTags()
        } catch (e) {
          this.$message.error(e.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 20px;
}

.error {
  color: #f87171;
  padding: 10px;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}
</style>
